var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"empresa-nombre":_vm.empresaNombre,"empresa-id":_vm.empresaId,"user":_vm.user}}),(!_vm.isBodega && !_vm.isLogistica)?_c('gestor-cotizaciones'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }